/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { Box } from '@mui/material';
import React from 'react'
import  Account  from '../views/account/Account'; 

const AccountPage = () => {
    return (
        <Box m={6}>
            <Account />
        </Box>
    )
}

export default AccountPage;